/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */

import moment from 'moment';
import PropTypes from 'prop-types';
import * as React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  Add,
  Close,
  Edit,
  ExpandLess,
  LocationOn,
  NotificationsActive,
  Settings,
  Task,
} from '@mui/icons-material';
import {
  Badge,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import {
  alpha,
  useTheme,
} from '@mui/material/styles';
import Grid from '@mui/material/Grid';

import AddEditLocationModalComponent from '../../../../../../pages/horse/Horse/components/LocationsCard/components/AddEditModal';
import CalendarEventDetailSettingsPage from '../../../../../../pages/settings/CalendarEventDetailSettingsPage';
import TaskDetailSettingsPage from '../../../../../../pages/settings/TaskDetailSettingsPage';
import TagReminderComponent from '../../../../../../pages/settings/TaskPage/reminders/components/TagReminder';
import { setSelectedBarnHorse } from '../../../../../../redux/app/actions';
import { getBarnBoardSuggestions } from '../../../../../../redux/board/actions';
import BarnHorsesAutocomplete from '../../../../../Autocompletes/BarnHorses';
import Horse from '../../../../../Horse';
import { getPlannerReminderSummary } from '../../../../../../utils/reminderHelpers';
import TagList from '../../../../../TagList';
import SelectEventTemplate from './components/SelectEventTemplate';

const TaskCalendarEventMenu = ({
  tagsFilter,
  taskTypeIdsFilter,
  open,
  includeBarnTasks,
  includeHorseTasks,
  includeCalendarEvents,
  onClose,
  onTaskSelect,
  onCalendarEventSelect,
  selectedSlot,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openAddTaskModal, setOpenAddTaskModal] = React.useState(false);
  const [openAddCalendarEventModal, setOpenAddCalendarEventModal] = React.useState(false);

  const [selectedTaskType, setSelectedTaskType] = React.useState(null)
  const [barnHorses, setBarnHorses] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);
  const [numHorseLocationsOutsideCurrentLocation, setNumHorseLocationsOutsideCurrentLocation] = React.useState(0);
  const [openAddEditHorseLocationModal, setOpenAddEditHorseLocationModal] = React.useState(null);
  const [selectedHorseLocation, setSelectedHorseLocation] = React.useState(null);
  const [menuEl, setMenuEl] = React.useState(null)
  const [openEventTemplateMenu, setOpenEventTemplateMenu] = React.useState(false)
  const [tab, setTab] = React.useState(0);

  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const horseLocationsByHorse = useSelector((state) => state.location.horseLocationsByHorse)
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  const upcomingDueDates = useSelector((state) => state.board.upcomingDueDates);
  const permissions = useSelector((state) => state.user.permissions);
  const selectedTagIds = new Set(barnHorses.map((horse) => Number(horse.pingumTagId)));
  const reminderSummary = getPlannerReminderSummary(upcomingDueDates.filter((reminder) => selectedTagIds.has(reminder.tag?.id)));
  const numHorsesWithReminders = reminderSummary.horseCount;
  const theme = useTheme();

  const headerBackgroundColor = (selectedTaskType
    && selectedTaskType.eventDataDefaultValues
    && selectedTaskType.eventDataDefaultValues.calendarDisplayColor)
    || (selectedSlot
      && selectedSlot.calendarEvent
      && selectedSlot.calendarEvent.eventData
      && selectedSlot.calendarEvent.eventData.Color
      && selectedSlot.calendarEvent.eventData.Color.value)
    || theme.palette.primary.main;
  const headerTextColor = theme.palette.getContrastText
    ? theme.palette.getContrastText(headerBackgroundColor)
    : '#fff';
  const selectedDateLabel = selectedSlot && selectedSlot.start
    ? moment(selectedSlot.start).format('dddd MMMM Do')
    : null;
  const headerTitle = selectedTaskType
    ? selectedTaskType.name
    : 'Create Task or Event';

  React.useEffect(() => {
    if (open) {
      setOpenAddEditHorseLocationModal(false);
      setSelectedHorseLocation(null)
      setMenuEl(null);
      setOpenEventTemplateMenu(false)
      setExpanded(false);
    }
    setSelectedTaskType(null)
  }, [open])

  React.useEffect(() => {
    setNumHorseLocationsOutsideCurrentLocation(barnHorses
      .filter((bh) => horseLocationsByHorse[bh.horse.id]
        && horseLocationsByHorse[bh.horse.id].find((hl) => hl.location.id !== selectedLocation.id)).length)
  }, [barnHorses, horseLocationsByHorse, selectedLocation])

  React.useEffect(() => {
    if (selectedSlot) {
      setBarnHorses((selectedSlot.barnHorses && selectedSlot.barnHorses
        .filter((id) => !!barnHorsesMap[parseInt(id, 10)]).map((id) => barnHorsesMap[parseInt(id, 10)][0])) || []);
      if (selectedSlot.taskType) {
        setSelectedTaskType(selectedSlot.taskType);
      }
      if (selectedSlot.calendarEvent) {
        setTimeout(() => {
          setTab(1);
        }, 500)
      } else {
        setTab(0);
      }
    }
  }, [selectedSlot]);

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      hideBackdrop
      id="quick-select-task-calendar-event-type-menu"
      sx={{ zIndex: (t) => (t.zIndex.drawer || 1200) + 5 }}
      PaperProps={{
        sx: {
          m: 0,
          maxWidth: 450,
          width: 450,
          zIndex: (t) => (t.zIndex.drawer || 1200) + 5,
        },
      }}
      open={!!open}
      onClose={() => onClose(false)}
    >
      <Box sx={{ mt: '2.5rem' }}>
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            px: 3,
            py: 2.5,
            backgroundColor: headerBackgroundColor,
            color: `${headerTextColor} !important`,
            backgroundImage: `linear-gradient(120deg, ${headerBackgroundColor}, ${alpha(headerBackgroundColor, 0.85)})`,
          }}
        >
          <Stack spacing={1.5}>
            <Stack
              direction={{
                xs: 'column',
                sm: 'row',
              }}
              spacing={2}
              alignItems={{
                xs: 'flex-start',
                sm: 'center',
              }}
              justifyContent="space-between"
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  minWidth: 0,
                  flex: 1,
                }}
              >
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: `1px solid ${alpha(headerTextColor, 0.4)}`,
                    backgroundColor: `${headerTextColor}1A`,
                    color: headerTextColor,
                  }}
                >
                  <Task />
                </Box>
                <Box
                  sx={{
                    minWidth: 0,
                    flex: 1,
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      margin: 0,
                      fontSize: '1.4rem',
                      fontWeight: 600,
                      lineHeight: '1.9rem',
                      width: '100%',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {headerTitle}
                  </Typography>
                  {selectedDateLabel && !selectedTaskType && (
                    <Typography variant="body2" sx={{ color: alpha(headerTextColor, 0.85) }}>
                      {selectedDateLabel}
                    </Typography>
                  )}
                </Box>

                <IconButton onClick={onClose}><Close sx={{ color: '#fff' }} /></IconButton>
              </Stack>
            </Stack>
            {selectedTaskType && (
              <TagList tags={selectedTaskType.tags} disableGutters />
            )}
            <Stack
              direction={{
                xs: 'column',
                sm: 'row',
              }}
              spacing={1.5}
              alignItems={{
                xs: 'flex-start',
                sm: 'center',
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  width: '100%',
                }}
              >
                <BarnHorsesAutocomplete
                  multiple
                  label=" "
                  showAdornment
                  pickerTitle="Select Horse(s) for Task"
                  value={barnHorses}
                  onSelectedBarnHorseChange={(newHorses) => {
                    setBarnHorses(newHorses);
                  }}
                  onSelect={(e, newHorses) => {
                    setBarnHorses(newHorses)
                  }}
                  limitTags={5}
                  barnHorses={(boardBarnHorses && boardBarnHorses.length > 0 && boardBarnHorses) || undefined}
                />
              </Box>
              {includeHorseTasks && barnHorses.length > 0 && (
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="View Locations of Selected Horses">
                    <IconButton
                      aria-label="Horse Locations"
                      onClick={() => setExpanded(!expanded)}
                      sx={{ color: headerTextColor }}
                    >
                      <Badge badgeContent={numHorseLocationsOutsideCurrentLocation} color="primary" invisible={numHorseLocationsOutsideCurrentLocation <= 0}>
                        <LocationOn />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={`${numHorsesWithReminders} selected horses with ${reminderSummary.reminderCount} reminders`}>
                    <IconButton
                      aria-label="Horse Reminders"
                      onClick={() => setExpanded(!expanded)}
                      sx={{ color: headerTextColor }}
                    >
                      <Badge badgeContent={reminderSummary.reminderCount} color="primary" invisible={reminderSummary.reminderCount <= 0}>
                        <NotificationsActive />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                </Stack>
              )}
            </Stack>
          </Stack>
        </DialogTitle>
      </Box>
      <DialogContent sx={{ p: 0 }}>
        <Grid container spacing={1}>
          {
            !expanded && (
              <Grid sx={{ flex: 1 }}>
                <SelectEventTemplate
                  tagsFilter={tagsFilter}
                  taskTypeIdsFilter={taskTypeIdsFilter}
                  open={open}
                  includeBarnTasks={includeBarnTasks}
                  includeHorseTasks={includeHorseTasks}
                  includeCalendarEvents={includeCalendarEvents}
                  onTaskSelect={(et) => {
                    // setSelectedTaskType(et);
                    // setActiveStep(1)
                    if (et) {
                      onTaskSelect(et, {
                        ...selectedSlot,
                        barnHorses: barnHorses.map((bh) => bh.pingumTagId),
                      });
                    }
                  }}
                  onCalendarEventSelect={(et) => {
                    onCalendarEventSelect(et);
                  }}
                  selectedSlot={selectedSlot}
                  setOpenAddCalendarEventModal={setOpenAddCalendarEventModal}
                  setOpenAddTaskModal={setOpenAddTaskModal}
                  tab={tab}
                  setTab={setTab}
                />
                {/* {
                  activeStep === 1 && (
                    <Collapse in={activeStep === 1} orientation="horizontal" sx={{ height: '100%' }}>
                      <SelectWorkflows
                        selectedSlot={{
                          ...selectedSlot,
                          barnHorses: barnHorses.map((bh) => bh.pingumTagId),
                        }}
                        selectedEventTemplate={selectedTaskType}
                        onConfirm={(replacementSlot) => {
                          if (selectedTaskType) { onTaskSelect(selectedTaskType, replacementSlot); }
                        }}
                        onBack={() => { setSelectedTaskType(null); setActiveStep(0); }}
                        onClose={onClose}
                        onEditEventTemplate={() => { }}
                        barnHorses={barnHorses}
                        setBarnHorses={setBarnHorses}
                      />
                    </Collapse>
                  )
                } */}
              </Grid>
            )
          }
          {expanded && (
            <Grid justifyContent="center" alignContent="center" sx={{ textAlign: 'center' }} size={12}>
              <Button variant="outlined" onClick={() => setExpanded(!expanded)} endIcon={<ExpandLess />}>Hide Locations & Reminders</Button>
            </Grid>
          )}
          {expanded && (
            <Grid size={12}>
              <Box
                sx={{
                  backgroundColor: blueGrey[50],
                  borderRadius: 4,
                  p: 2,
                  mx: 2,
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                      }}
                    >
                      <LocationOn color="secondary" />
                      <Typography
                        variant="h6"
                        component="h3"
                        fontWeight={500}
                        sx={{ fontSize: '1.2rem' }}
                      >
                        Current Location(s) of Horses
                      </Typography>
                    </Box>
                    <Tooltip title="Add Horses to Location">
                      <IconButton
                        sx={{ padding: 0 }}
                        onClick={() => {
                          setSelectedHorseLocation(null); setOpenAddEditHorseLocationModal(true);
                        }}
                      >
                        <Add />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <List
                    sx={{
                      width: '100%',
                      maxHeight: 400,
                      height: 400,
                      overflow: 'auto',
                    }}
                    dense
                  >
                    {barnHorses.filter((bh) => horseLocationsByHorse[bh.horse.id]).map((bh) => (
                      <ListItem
                        divider
                        key={bh.id}
                        disablePadding
                      >
                        <Box
                          sx={{
                            flex: 1,
                            mt: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Horse horse={bh.horse} size={32} textWidth={90} clickable onClick={() => { dispatch(setSelectedBarnHorse(bh)); }} />
                            {
                              horseLocationsByHorse[bh.horse.id].filter((hl) => hl.location.id !== selectedLocation.id).length > 0 && (
                                <Chip size="small" variant="outlined" color="warning" label="Multiple Locations Found" />
                              )
                            }
                          </Box>
                          <List
                            dense
                            sx={{
                              width: '100%',
                              py: 0,
                            }}
                          >
                            {
                              horseLocationsByHorse[bh.horse.id].map((hl) => (
                                <ListItem
                                  key={hl.id}
                                  disablePadding
                                  secondaryAction={(
                                    <IconButton
                                      onClick={() => { setSelectedHorseLocation(hl); setOpenAddEditHorseLocationModal(true); }}
                                    ><Edit />
                                    </IconButton>
                                  )}
                                >
                                  <Box sx={{ flex: 1 }}>

                                    <ListItemText
                                      primary={hl.location.name}
                                      secondaryTypographyProps={{ component: 'div' }}
                                      secondary={(
                                        <Box>
                                          <div>{`${moment(hl.startDate).format('ll')} - ${!hl.endDate
                                            ? 'No End Date'
                                            : moment(hl.endDate).format('ll')}`}
                                          </div>
                                          {
                                            hl.location.id === selectedLocation.id && <Chip size="small" label="Current Planning Location" />
                                          }
                                        </Box>
                                      )}
                                    />
                                  </Box>
                                </ListItem>
                              ))
                            }
                          </List>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Box>
            </Grid>
          )}
          {expanded && (
            <Grid size={12}>
              <Box
                sx={{
                  backgroundColor: blueGrey[50],
                  borderRadius: 4,
                  p: 2,
                  mx: 2,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  <NotificationsActive color="error" />
                  <Typography
                    variant="h6"
                    component="h3"
                    fontWeight={500}
                    sx={{ fontSize: '1.2rem' }}
                  >
                    Reminders
                  </Typography>
                </Box>
                <Box>
                  <List
                    sx={{
                      width: '100%',
                      maxHeight: 400,
                      height: 400,
                      overflow: 'auto',
                    }}
                    dense
                  >
                    {barnHorses.map((bh) => {
                      const horseReminders = reminderSummary.reminders.filter((reminder) => reminder.tag.id === Number(bh.pingumTagId));

                      return (
                        <ListItem
                          divider
                          key={bh.id}
                          disablePadding
                        >
                          <Box
                            sx={{
                              flex: 1,
                              mt: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Horse horse={bh.horse} size={32} textWidth={90} clickable onClick={() => { dispatch(setSelectedBarnHorse(bh)); }} />
                              {
                                horseReminders.length > 0 && (
                                  <Chip size="small" variant="outlined" color="warning" label="Reminders Found" />
                                )
                              }
                            </Box>
                            {
                              horseReminders.length > 0
                                ? (
                                  <List
                                    dense
                                    sx={{
                                      width: '100%',
                                      py: 0,
                                    }}
                                  >
                                    {
                                      horseReminders.map((tr) => (
                                        <ListItem
                                          key={tr.id}
                                          disablePadding
                                        // secondaryAction={(
                                        //   <IconButton
                                        //     onClick={() => { setSelectedHorseLocation(hl); setOpenAddEditHorseLocationModal(true); }}
                                        //   ><Edit />
                                        //   </IconButton>
                                        // )}
                                        >
                                          {/* <ListItemIcon>
                                            <LocationOn />
                                          </ListItemIcon> */}
                                          <Box sx={{ flex: 1 }}>
                                            <TagReminderComponent
                                              key={`task-item-${tr.id}`}
                                              tagReminder={tr}
                                              fullScreen={false}
                                              includeHorse={false}
                                              includeTask
                                              condensed
                                              triggerDataRefresh={() => dispatch(getBarnBoardSuggestions(boardBarnHorses))}
                                            />
                                          </Box>
                                        </ListItem>
                                      ))
                                    }
                                  </List>
                                )
                                : (
                                  <Typography color="secondary" gutterBottom>No upcoming reminders</Typography>
                                )
                            }
                          </Box>
                        </ListItem>
                      )
                    })}
                  </List>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>

        <Menu
          id="menu-appbar"
          anchorEl={menuEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: 0,
            left: 0,
          }}
          open={openEventTemplateMenu}
          onClose={() => {
            setMenuEl(null);
            setOpenEventTemplateMenu(false)
          }}
        >
          <ListItemButton
            onClick={() => {
              setOpenAddTaskModal(true)
              setMenuEl(null);
              setOpenEventTemplateMenu(false)
            }}
          >
            <ListItemIcon>
              <Settings color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Edit Task Type" secondary="Manage default settings for all occurrences of this task type" />
          </ListItemButton>
        </Menu>

        <CalendarEventDetailSettingsPage
          modal
          navigate={() => { }}
          openModal={openAddCalendarEventModal}
          passedInModalId="new"
          onCloseModal={(newCalendarEvent) => {
            setOpenAddCalendarEventModal(false);
            if (newCalendarEvent && newCalendarEvent.id) {
              onCalendarEventSelect(newCalendarEvent);
            }
          }}
        />

        <TaskDetailSettingsPage
          modal
          navigate={() => { }}
          openModal={openAddTaskModal}
          passedInModalId={selectedTaskType
            ? `${selectedTaskType.id}`
            : 'new'}
          onCloseModal={(newTaskType) => {
            setOpenAddTaskModal(false);
            if (newTaskType && newTaskType.id) {
              setSelectedTaskType(newTaskType);
              onTaskSelect(newTaskType, {
                ...selectedSlot,
                barnHorses: barnHorses.map((bh) => bh.pingumTagId),
              });
            }
          }}
        />
        <AddEditLocationModalComponent
          open={!!openAddEditHorseLocationModal}
          horseIds={barnHorses.map((bh) => bh.id)}
          onClose={() => { setOpenAddEditHorseLocationModal(false); setSelectedHorseLocation(null) }}
          startDate={new Date()}
          endDate={null}
          location={selectedLocation}
          horseId={selectedHorseLocation && selectedHorseLocation.horse.id}
          horseLocation={selectedHorseLocation}
        />
      </DialogContent>
      <Divider />
      <DialogActions
        sx={{
          pt: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        {(permissions.admin || permissions.owner)
          ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
                width: '100%',
              }}
            >
              <Typography
                component="span"
                sx={{ fontWeight: 300 }}
              >Don&#39;t see the right option?
              </Typography>
              {
                tab === 0
                  ? (
                    <Box><Button size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedTaskType(null); setOpenAddTaskModal(true) }} endIcon={<Add />}>New Task</Button></Box>
                  )
                  : (
                    <Box><Button size="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpenAddCalendarEventModal(true) }} endIcon={<Add />}>New Calendar</Button></Box>
                  )
              }
              {
                tab === 0
                  ? (
                    <Box><Button size="small" color="secondary" onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate('/settings/tasks') }} endIcon={<Settings />}>Manage Tasks</Button></Box>
                  )
                  : (

                    <Box><Button size="small" color="secondary" onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate('/settings/calendar') }} endIcon={<Settings />}>Manage Calendars</Button></Box>
                  )
              }
            </Box>

          )
          : <Box />}
      </DialogActions>
    </Drawer>
  );
}

TaskCalendarEventMenu.propTypes = {
  tagsFilter: PropTypes.array,
  open: PropTypes.bool,
  includeBarnTasks: PropTypes.bool,
  includeHorseTasks: PropTypes.bool,
  includeCalendarEvents: PropTypes.bool,
  onClose: PropTypes.func,
  onTaskSelect: PropTypes.func,
  onCalendarEventSelect: PropTypes.func,
  selectedSlot: PropTypes.object,
};

TaskCalendarEventMenu.defaultProps = {
  tagsFilter: [],
  open: false,
  includeBarnTasks: true,
  includeHorseTasks: false,
  includeCalendarEvents: true,
  onClose: () => { },
  onTaskSelect: () => { },
  onCalendarEventSelect: () => { },
  selectedSlot: null,
};

export default TaskCalendarEventMenu;
